/**
 * API Types
 */

import type { FilterPreset } from './preset.types';

/**
 * Generic API response wrapper
 */
export interface ApiResponse<T> {
  success: boolean;
  data?: T;
  error?: string;
}

/**
 * API Error class
 */
export class ApiError extends Error {
  constructor(
    message: string,
    public status: number,
    public code?: string
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

/**
 * Storage mode for presets
 */
export type StorageMode = 'server' | 'local' | 'mixed';

/**
 * Preset save request payload
 */
export interface PresetSaveRequest {
  name: string;
  filterRoot: FilterPreset['filterRoot'];
}

/**
 * Preset rename request payload
 */
export interface PresetRenameRequest {
  name: string;
}
